import React from 'react';
import PrivilegeCode from '../../../consts/PrivilegeCode';
import {
  Button,
  Table,
  Column,
  PageBar,
  Dialog,
  Icon,
  AutoComplete,
  PopOver,
  OverlayTrigger,
} from '@tencent/spaui';

import { RPCFactory } from '../../../utils/RequestUtil';

import { store } from '../../../store/Store';
import { GlobalStateAction } from '../../../actions/GlobalStateAction';
import GroupDetailPresentationalComponent from './GroupDetailComponent';
import ReactDOM from 'react-dom';

const pageSizeList = [5, 10, 20];

export default class GroupManagePage extends React.Component {
  componentDidMount() {
    this.getGroupList(this.state.pageSize, this.state.pageIndex, this.state.searchItemValue);
  }
  constructor(props) {
    super(props);

    this.state = {
      searchItemValue: '',
      _searchItemValue: '',
      pageSize: 10,
      pageIndex: 1,
      data: [],
      showDeleteGroup: false,
      showDeleteSuccess: false,
      groupHasDistributeRole: false,
    };
  }

  onKeyPressHandler = (event, value) => {
    if (event.key === 'Enter') {
      this.setState({
        searchItemValue: this.state._searchItemValue,
      })
      this.onSearchGroup();
    }
  };
  onClearSearchItem = (event) => {
    this.setState({ searchItemValue: '', _searchItemValue: '' });
    setTimeout(() => {
      this.onSearchGroup();
    }, 0);
  };

  /**
   * 点击查询按钮
   * @param event
   */
  onSearchGroup = (event) => {
    this.setState({ pageIndex: 1 });
    this.getGroupList(this.state.pageSize, 1, this.state._searchItemValue);
  };

  onChangeSearchItemValue = (event, value) => {
    // this.setState({ searchItemValue: value });
    this.setState({ _searchItemValue: value });
  };

  /**
   * 页码点击
   * @param event
   * @param value
   */
  onChangePageIndex = (event, value) => {
    this.setState({ pageIndex: value });
    this.getGroupList(this.state.pageSize, value, this.state.searchItemValue);
  };

  /**
   * 页面条目数量点击
   * @param event
   * @param value
   */
  onChangePageSize = (event, value) => {
    this.setState({ pageSize: value });
    this.getGroupList(value, this.state.pageIndex, this.state.searchItemValue);
  };

  getGroupList = (pageSize, pageIndex, groupName) => {
    store.dispatch({ type: GlobalStateAction.SHOW_LOADING });
    RPCFactory.employeeManage
      .getGroupList(pageSize, pageIndex, groupName)
      .done((data) => {
        this.setState({
          data: data.entities,
          totalSize: data.size,
        });
        store.dispatch({ type: GlobalStateAction.HIDE_LOADING });
      })
      .fail((ret, msg) => {
        store.dispatch({ type: GlobalStateAction.HIDE_LOADING });
        window.alert(`获取团队列表失败，错误信息：${msg}`);
      });
  };
  renderOperate = (type, name, value, data) => {
    if (type == 'head') {
      return value;
    }
    if (data.userGroupId == '0') {
      return (
        <div>
          <a
            href={'javascript:;'}
            onClick={(e) => {
              this.showGroupDetail(data.userGroupId, data.userGroupName);
            }}
          >
            查看
          </a>
        </div>
      );
    }
    return (
      <div>
        <a
          href={'javascript:;'}
          onClick={(e) => {
            this.showGroupDetail(data.userGroupId, data.userGroupName);
          }}
        >
          编辑
        </a>
        <a
          href={'javascript:;'}
          onClick={(e) => {
            this.deleteGroup(data.userGroupId);
          }}
        >
          删除
        </a>
      </div>
    );
  };

  onGroupAddCancel = () => {
    ReactDOM.unmountComponentAtNode(document.getElementById('groupDetail'));
  };

  onGroupConfirm = () => {
    this.getGroupList(this.state.pageSize, this.state.pageIndex, this.state.searchItemValue);
    this.onGroupAddCancel();
  };
  deleteGroup(userGroupId) {
    this.userGroupIdForDelete = userGroupId;
    // get group distribute role
    RPCFactory.employeeManage
      .groupInDistributeRule(userGroupId)
      .done((data) => {
        this.setState({
          groupHasDistributeRole: data,
        });
      })
      .fail((ret, msg) => {
        window.alert(`接口失败，错误信息：${msg}`);
      });
    this.setState({
      showDeleteGroup: true,
    });
  }
  showGroupDetail = (userGroupId, userGroupName) => {
    ReactDOM.render(
      <GroupDetailPresentationalComponent
        onConfirm={this.onGroupConfirm}
        onCancel={this.onGroupAddCancel}
        userGroupId={`${userGroupId}`}
        userGroupName={userGroupName}
        show={true}
      />,
      document.getElementById('groupDetail'),
    );
  };
  handleCloseDeleteGroup() {
    this.setState({
      showDeleteGroup: false,
    });
  }
  handleCloseDeleteSuccess() {
    this.setState({
      showDeleteSuccess: false,
    });
  }
  handleConfirmDeleteGroup() {
    this.handleCloseDeleteGroup();
    RPCFactory.employeeManage
      .deleteGroup(this.userGroupIdForDelete)
      .done((data) => {
        this.setState({
          showDeleteSuccess: true,
        });
        this.getGroupList(this.state.pageSize, this.state.pageIndex, this.state.searchItemValue);
      })
      .fail((code, msg) => {
        window.alert(`获取员工信息失败，失败信息：${msg}`);
        this.props.onCancel();
      });
  }

  renderGroupName = (type, name, value, data) => {
    const popoverstyle = {
      maxWidth: '550px',
    };
    const tips = '若想添加／删除默认团队成员，请直接在其他团队删除／添加成员';

    const popover = (
      <PopOver style={popoverstyle}>
        <div className="poptable">{tips}</div>
      </PopOver>
    );
    if (type == 'head') {
      return <div>{value}</div>;
    }
    return (
      <span>
        {value}
        {data.userGroupId == '0' && (
          <OverlayTrigger trigger="hover" delay={100} overlay={popover}>
            <i className="icon icon-help">
              <i></i>
            </i>
          </OverlayTrigger>
        )}
      </span>
    );
  };

  render() {
    const canAddEmployee = window.pageProps.privileges.includes(PrivilegeCode.EMPLOYEE_USER_GROUP_ADD_UPDATE.getCode());
    const canEditEmployee = window.pageProps.privileges.includes(
      PrivilegeCode.EMPLOYEE_USER_GROUP_ADD_UPDATE.getCode(),
    );

    return (
      <div className="main">
        <Dialog
          show={this.state.showDeleteSuccess}
          time={2000}
          timeCallback={this.handleCloseDeleteSuccess.bind(this)}
          type="tip"
          iconType="success"
        >
          删除团队成功!
        </Dialog>
        <Dialog
          type="normal"
          className="spaui-dialog-confirm-normal"
          title="确认是否删除团队"
          iconType="tip"
          show={this.state.showDeleteGroup}
          onClose={this.handleCloseDeleteGroup.bind(this)}
          onSubmit={this.handleConfirmDeleteGroup.bind(this)}
          onCancel={this.handleCloseDeleteGroup.bind(this)}
          cancelLabel={this.state.groupHasDistributeRole ? '知道了' : '取消'}
          submitButton={!this.state.groupHasDistributeRole}
        >
          {this.state.groupHasDistributeRole ? (
            <div>该团队是当前生效的线索分配规则中的唯一可分配团队，请先更改线索分配规则，才可删除该团队。</div>
          ) : (
            <div>删除后该团队所有成员将归属于默认团队，成员的线索转移至默认团队中，确认是否删除？</div>
          )}
        </Dialog>

        <div className="card">
          <div className="datarea">
            <div className="toolbars">
              <div className="toolbar table-toolbar">
                <div className="toolbar-left">
                  <Button
                    onClick={(e) => {
                      if (canAddEmployee) {
                        this.showGroupDetail('');
                      }
                    }}
                    displayType="primary"
                  >
                    <Icon type="add" />
                    添加团队
                  </Button>
                </div>
                <div className="toolbar-right">
                  <AutoComplete
                    value={this.state._searchItemValue}
                    onChange={this.onChangeSearchItemValue}
                    onClickSearchIcon={this.onSearchGroup}
                    onKeyPress={this.onKeyPressHandler}
                    onClear={this.onClearSearchItem}
                  />
                </div>
              </div>
            </div>
            <div className="datalist">
              <Table data={this.state.data}>
                <Column name="userGroupName" render={this.renderGroupName}>
                  团队名称
                </Column>
                <Column name="userCount">员工人数</Column>
                <Column show={canEditEmployee} name="operate" render={canEditEmployee ? this.renderOperate : ''}>
                  操作
                </Column>
              </Table>
            </div>
            <PageBar
              value={this.state.pageIndex}
              pageSize={this.state.pageSize}
              totalSize={this.state.totalSize}
              pageSizeList={pageSizeList}
              onChange={this.onChangePageIndex}
              onPageSizeChange={this.onChangePageSize}
            />
          </div>
        </div>
        <div id="groupDetail"></div>
      </div>
    );
  }
}
